import Head from "next/head";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

type SeoHeadProps = {
  title?: string;
  description?: string;
  canonicalTag?: boolean;
  isProduction?: boolean;
  isNoIndex?: boolean;
};

const SeoHead = ({
  title,
  description,
  canonicalTag = true,
  isProduction,
  isNoIndex,
}: SeoHeadProps) => {
  const router = useRouter();
  const [origin, setOrigin] = useState("");

  useEffect(() => {
    if (typeof window !== "undefined") {
      setOrigin(window?.location?.origin);
    }
  }, []);

  const currentPath = router?.asPath;

  return (
    <Head>
      {title && <title>{title}</title>}
      {isNoIndex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : isProduction ? (
        <meta name="robots" content="index, follow" />
      ) : (
        <meta name="robots" content="noindex, nofollow" />
      )}
      {description && <meta name="description" content={description} />}
      {canonicalTag && <link rel="canonical" href={`${origin}${currentPath}`} />}
      <link rel="alternate" hrefLang="fr" href={`${origin}${currentPath}`} />
      <link rel="alternate" hrefLang="ar" href={`${origin}/ar${currentPath}`} />
    </Head>
  );
};

export default SeoHead;
